import {getCardType} from '../../selectors/CardOptionSelectors/CardOptionSelectors';
import {isCardTypeSupported} from '../../selectors/DisplayableCardsSelectors/DisplayableCardsSelectors';
import {getSettings} from '../../selectors/selectors';
import store from '../../store/store';
import bigQueryMetricRecorder from '../../tracking/bigQueryMetricRecorder';
import Track from '../../utils/tracking';

const cardSupportedErrorKey = 'errors.formFields.unsupportedCard';

const cardTypeSupportedEnabled = () => getSettings(store.getState()).unsupported_card_type_payment_validation_enabled;

const cardTypeSupported = () => {
  if (cardTypeSupportedEnabled() && !isCardTypeSupported(store.getState())) {
    const cardDefinition = getCardType(store.getState());
    const cardType = cardDefinition.name || cardDefinition.iconName;
    if (cardType) {
      try {
        bigQueryMetricRecorder('UnsupportedCardTypeInputted',
          [{name: 'cardType', value: cardType}], [], 'impression');
      } catch (error) {
        Track.track(error);
      }
    }
    return cardSupportedErrorKey;
  }
};

export default cardTypeSupported;
